export function getNotPresentFrom(arrayOne: Array<string>, arrayTwo: Array<string>): Array<string> {
  if (arrayOne == null || arrayTwo == null) { return arrayOne; }
  return arrayOne.filter(id => !arrayTwo.includes(id));
}
